import React, { useContext } from 'react'
// Components
import TableLoader from 'components/utils/Table/Table'
// Styles
import * as R from './Table.styles'
// Additional
import Settings from './Table.settings'
import { TimespaceContext } from 'components/Timespaces/__Timespaces.context'
import { SportsmanStatSummaryRecord } from 'data/SportsmanStatSummaryRecord'
import { AppContext } from 'App'
import { Data } from 'helpers/data'

const SportsmanStatSummariesTable: React.FC = () => {
  const { db: a_db, alert: a_alert } = useContext(AppContext)

  const { params: ts_params } = useContext(TimespaceContext)

  const loadData = async () => {
    if (ts_params?.timespace_id)
      return await Data.getSportsmanStatSummariesByTimespaceId(
        a_db!,
        ts_params?.timespace_id,
        { alert: a_alert }
      )

    return await Data.getAllSportsmanStatSummaries(a_db!, { alert: a_alert })
  }

  return (
    <TableLoader<SportsmanStatSummaryRecord>
      loadDataFn={loadData}
      settings={Settings}
      style={{
        thead: R.TableHeadStyle,
        theadH: R.TableCellStyle,
        theadR: R.TableRowStyle,
        tbodyR: R.TableRowStyle,
        tbodyD: R.TableCellStyle,
      }}
    />
  )
}

export default SportsmanStatSummariesTable
